import { useState, useEffect } from 'react';

export const useLocalStorage = (key, initialValue) => {

    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);

            if (item !== null && item !== 'undefined') {
                return JSON.parse(item);
            }
            return initialValue;
        } catch (error) {
            console.error("Error reading from local storage:", error);
            return initialValue;
        }
    });
  
    useEffect(() => {
        try {
            if (storedValue === null) {
                window.localStorage.removeItem(key);
            } else {
                window.localStorage.setItem(key, JSON.stringify(storedValue));
            }
        } catch (error) {
            console.error(error);
        }
    }, [key, storedValue]);
  
    return [storedValue, setStoredValue];
};